// extracted by mini-css-extract-plugin
export var childrenContainer = "_bd-0";
export var virtualScrollArea = "_bd-1";